module.exports = __webpack_public_path__ + "media/components/src/assets/images/embellishments/gifts/gift_01-5cf6231d1a0728f07eaaccd7260f347c.svg";